import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
// import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { RouterProvider } from "react-router-dom";
import Router from "./Router";
import { ClerkProvider } from "@clerk/clerk-react";
import { GoogleOAuthProvider } from "@react-oauth/google";

const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  throw new Error("Add your Clerk Publishable Key to the .env file");
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId="262604213043-8rtunn5f0bsoprbhfiq3lq72q01hm4f5.apps.googleusercontent.com">
      <ClerkProvider publishableKey={PUBLISHABLE_KEY} afterSignOutUrl="/">
        <RouterProvider router={Router} />
      </ClerkProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);

reportWebVitals();
